export const ERROR_START_TITLE = "###";
const ERROR_LIST_ITEM = "||";
const ERROR_SUB_ITEM = "@";

export const parseFormattedError = (errorMessage) => {
  if (!errorMessage || !errorMessage.startsWith(ERROR_START_TITLE)) {
    return null;
  }

  // Remove the ### prefix
  const cleanMessage = errorMessage.substring(3);

  // Split the message into title and items
  const [title, ...itemsStr] = cleanMessage.split(ERROR_LIST_ITEM);

  // Parse each item into title and subitems
  const items = itemsStr.map((item) => {
    const [itemTitle, ...subItems] = item.split(ERROR_SUB_ITEM);
    return {
      title: itemTitle.trim(),
      subItems: subItems.map((subItem) => subItem.trim()),
    };
  });

  return {
    title: title.trim(),
    items,
  };
};
